import Vue from 'vue';
import moment from 'moment';
import Notifications from 'vue-notification';
import { abilitiesPlugin } from '@casl/vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFilter, faSortAmountDown, faSortAmountUpAlt, faMapMarkerAlt, faPlus, faQuestionCircle, faCog,
  faMobile, faDesktop, faLink, faTimes, faSave, faPhone, faEnvelope,
  faChevronDown, faChevronUp, faChevronRight, faChevronLeft, faArrowLeft, faTrash, faSearch,
  faChevronCircleDown, faChevronCircleUp, faChevronCircleRight, faChevronCircleLeft,
  faExclamationCircle, faTimesCircle, faInfoCircle, faCheckCircle, faPen,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import * as Sentry from '@sentry/vue';

import App from './App.vue';
import { router } from './router';
import store from './store';
import logger from './services/logger';
// import gate from './policies';
import './registerServiceWorker';

// Plugins
import axios from './plugins/axios';
import i18n from './i18n';
import '@/mixins/mapIcon';
import mapFunctions from '@/mixins/mapFunctions';
import transformers from '@/mixins/transformers';

Vue.mixin({
  methods: mapFunctions, transformers,
});

library.add(
  faFilter, faSortAmountDown, faSortAmountUpAlt, faMapMarkerAlt, faPlus, faQuestionCircle,
  faCog, faMobile, faDesktop, faLink, faTimes, faSave, faPhone, faEnvelope,
  faChevronDown, faChevronUp, faChevronRight, faChevronLeft, faArrowLeft, faTrash, faSearch,
  faChevronCircleDown, faChevronCircleUp, faChevronCircleRight, faChevronCircleLeft,
  faExclamationCircle, faTimesCircle, faInfoCircle, faCheckCircle, faPen,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.filter('capitalize', (value) => {
  if (!value) return '';
  return value.toString().charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('capitalizeEachWord', (value) => {
  if (!value) return '';
  return value.toString().split(' ').map(val => val.charAt(0).toUpperCase() + val.slice(1)).join(' ');
});

Vue.filter('dateTime', (value) => {
  if (!value) return '';
  return moment.unix(value).format('DD-MM-YYYY, HH:mm');
});

Vue.filter('dateFromInput', (value) => {
  if (!value) return '';
  return moment(value).format('DD-MM-YYYY');
});

Vue.filter('dateToInput', (value) => {
  if (!value) return '';
  return moment(value).format('YYYY-MM-DD');
});

Vue.filter('mapObjectLabel', (mapObject) => {
  if (!mapObject) {
    return '';
  }
  if (mapObject.mapObjectLabel
    && mapObject.mapObjectLabel.data
    && mapObject.mapObjectLabel.data.label
    && mapObject.mapObjectLabel.data.label.length > 0
  ) {
    return mapObject.mapObjectLabel.data.label;
  }
  if (mapObject.label) {
    return mapObject.label;
  }
  return mapObject.name;
});

Vue.use(abilitiesPlugin, store.getters.ability);
Vue.use(Notifications);
Vue.use(logger);

// Todo: move to seperate file
// eslint-disable-next-line consistent-return
axios.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 401) {
    if (error.response.data.error_description) {
      Vue.prototype.$notify({
        type: 'error',
        title: error.response.data.error ? error.response.data.error : 'Unauthorized',
        text: error.response.data.error_description,
        duration: 4000,
      });
    }
    if (!router.currentRoute || router.currentRoute.name !== 'logout') {
      router.push({ name: 'logout', query: { reason: 'session-expired' } });
    }
  } else if (error.response.status === 400) {
    const { title, messages } = error.response.data.data;
    Object.keys(messages).forEach((key) => {
      messages[key].forEach((message) => {
        Vue.prototype.$notify({
          type: 'error',
          title,
          text: message,
          duration: 4000,
        });
      });
    });
  } else if (error.response.status === 403) {
    if (error.response.data.data && error.response.data.data.detail) {
      Vue.prototype.$notify({
        type: 'error',
        title: error.response.data.error ? error.response.data.error : 'Error',
        text: error.response.data.detail,
        duration: 4000,
      });
    }
  }
  return Promise.reject(error);
});

Sentry.init({
  Vue,
  dsn: 'https://f2f2aa5f51fb11161b70799140446900@sentry.rapide.nl/33',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 50% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/staging\.c-tip\.com/, /^https:\/\/app\.c-tip\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

new Vue({
  router,
  store,
  axios,
  i18n,
  // gate,
  render: h => h(App),
}).$mount('#app');
